<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12.0004"
      cy="11.9999"
      r="8.85"
      stroke="white"
      stroke-width="1.5"
    />
    <circle cx="12.0002" cy="12" r="4.8" fill="white" />
  </svg>
</template>
